import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/freezeLifecycleSagas";
import { VIEW_OPTIONS } from "../constants";

const ViewSelector = () => {
  const dispatch = useDispatch();

  const selectedView = useSelector((state) => state.freezeLifecycle.selectedFilters.moduleView);

  return (
    <MultiSelectDropdown
      options={VIEW_OPTIONS}
      selectedFilters={selectedView}
      placeholder="Select View"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedView.id) return;
        dispatch(actionCreators.updateModuleView(data));
      }}
    />
  );
};

export default ViewSelector;
